import { createUrl } from '@cloudsuite/mosaic-shared/scripts/base-url.js'
import { fetcher } from 'components/shared/fetcher.js'

export interface ConfigurationData {
  length: number;
  width: number | null;
  quantity: number;
}

export interface WeightCalculationResponse {
  id: number;
  weight: string;
  uom_product: string;
  max_length: number | null;
  max_width: number | null;
  price: string;
  amount: string;
  uom_parameters: string;
}

export interface StoreFrontApiError {
  api_error_code: number;
  api_error_code_description: string;
  description: string;
  message: string;
}

export type CalculateWeightResponse = WeightCalculationResponse | StoreFrontApiError

interface AddToBasketResponse {
  identifier: string;
  items: any[];
  item_count: number;
  price_total: number;
  api_link: string;
}

export class WebshopCommunicator {
  updateBasket = async (basketId: string, productId: number, configurationData: ConfigurationData, memo?: string) => {
    const url = await createUrl(`api/v1/basket/v2/${basketId}/weight-calculation-item/${productId}/`)

    const req = await fetcher.fetch(
      url,
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          configuration_data: configurationData,
          memo: memo
        })
      }
    )

    return await req.json() as AddToBasketResponse
  }

  addToBasket = async (basketId: string, productId: number, configurationData: ConfigurationData, memo?: string) => {
    const url = await createUrl(`api/v1/basket/v2/${basketId}/weight-calculation-item/`)

    const req = await fetcher.fetch(
      url,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_id: productId,
          configuration_data: configurationData,
          memo: memo
        })
      }
    )

    return await req.json() as AddToBasketResponse
  }

  calculateWeight = async (productId: number, params: URLSearchParams): Promise<CalculateWeightResponse> => {
    const url = await createUrl(`api/v1/product/v2/${productId}/weight-configurator/?${params.toString()}`)
    const req = await fetcher.fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    })

    const data = await req.json()

    return data as CalculateWeightResponse
  }
}

export const webshopCommunicator = new WebshopCommunicator()
